import { Collapse } from 'antd';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { routeFileSelector } from '../../../../utilz/i18n';
import AdditionalQuoteSearchOptions from './Filters/AdditionalQuoteSearchOptions';
import QuoteSearch from './Filters/QuoteSearch';
import ShiperConsigneeQuoteSearch from './Filters/ShiperConsigneeQuoteSearch';

const SearchQuoteFilterContent = ({ form }) => {
  const [activeKey, setActiveKey] = useState('1');

  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const handleTabClick = useCallback((keys) => {
    if (keys?.[1]) {
      setActiveKey(keys[1]);
    } else {
      setActiveKey('');
    }
  }, []);

  const collapseItems = useMemo(
    () => [
      {
        key: '1',
        label: t('translation:searchQuote.filter.titles.shipmentSearch'),
        children: <QuoteSearch form={form} />,
      },
      {
        key: '2',
        label: t('translation:searchQuote.filter.titles.additional'),
        children: <AdditionalQuoteSearchOptions form={form} />,
      },
      {
        key: '3',
        label: t('translation:default.fields.shipper'),
        children: <ShiperConsigneeQuoteSearch type={1} form={form} />,
      },
      {
        key: '4',
        label: t('translation:default.fields.consignee'),
        children: <ShiperConsigneeQuoteSearch type={2} form={form} />,
      },
    ],
    [form, t],
  );

  return (
    <Collapse
      ghost
      className="filter-collapse-container px-16"
      activeKey={activeKey}
      onChange={handleTabClick}
      items={collapseItems}
    />
  );
};

export default SearchQuoteFilterContent;
